import { localStorageGet } from '@alexis/helpers/localStorage';

import { GENZO_IDENTIFIER_ID } from '@constants/localStorage';

export function getGenzoIdentifierId(): string {
  return localStorageGet(GENZO_IDENTIFIER_ID) || '00000000-0000-0000-0000-900000000000';
}
